import React from 'react';

const AuthzSubjectFormModal = React.lazy(() => import('../components/FormModal'));
const authzSubjectModalRegistry = {
    core_authzSubjectId: AuthzSubjectFormModal
};
export default authzSubjectModalRegistry;
